"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _UserBadge = _interopRequireDefault(require("@rsuite/icon-font/lib/people/UserBadge"));

// Generated by script, don't edit it please.
var UserBadge = (0, _createSvgIcon["default"])({
  as: _UserBadge["default"],
  ariaLabel: 'user badge',
  category: 'people',
  displayName: 'UserBadge'
});
var _default = UserBadge;
exports["default"] = _default;
module.exports = exports.default;